import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { recover } from "../../requests/auth";
import { createSignal } from "solid-js";

export default function useRecoverPassword() {
  const [loading, setLoading] = createSignal(false);
  const [form, setForm] = createStore({
    email: "",
    code: "",
  });

  const { successToast, errorToast } = useApplication();

  const onFormInput = (name, value) => {
    setForm(name, value);
  };

  const onSubmit = async (ev) => {
    ev.preventDefault();
    await onForgetPassword();
  }

  const onRecoverPassword = async () => {
    setLoading(true);
    try {
      const { data } = await recover({
        ...form
      });

      successToast(data.message);
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    form,
    onRecoverPassword,
    onSubmit,
    onFormInput,
  };
}
